import type { ClauseWithConsent } from 'constants/_types/ClauseWithConsent';

export const compareClauses = (clauseA: ClauseWithConsent, clauseB: ClauseWithConsent) => clauseA.clauseId === clauseB.clauseId;
